import CosmosAdminDbRecordBase from '@/models/CosmosAdminDbRecordBase'

export default class MasterRecord extends CosmosAdminDbRecordBase {
  public description: string
  public isDeleted: boolean
}
